import { useTheme as useThemeContext } from "../contexts/ThemeContext";

export const useTheme = useThemeContext;
